// A large collection of fun, memorable words for game codes
export const GAME_WORDS = [
  // Food & Drinks
  'PIZZA', 'TACOS', 'SUSHI', 'BURGER', 'WAFFLE', 'PANCAKE', 'COOKIE', 'CANDY',
  'CHOCOLATE', 'CARAMEL', 'BANANA', 'APPLE', 'ORANGE', 'STRAWBERRY', 'BLUEBERRY',
  'WATERMELON', 'PINEAPPLE', 'MANGO', 'AVOCADO', 'TOMATO', 'POTATO', 'CARROT',
  'BROCCOLI', 'SPINACH', 'MUSHROOM', 'PEPPER', 'ONION', 'GARLIC', 'GINGER',
  'CINNAMON', 'VANILLA', 'MINT', 'BASIL', 'THYME', 'ROSEMARY', 'SAGE',
  'COFFEE', 'TEA', 'JUICE', 'SMOOTHIE', 'MILKSHAKE', 'LEMONADE', 'HOTCHOCO',
  'ICECREAM', 'PUDDING', 'CUSTARD', 'JELLY', 'MARSHMALLOW', 'POPCORN', 'CHIPS',
  'PRETZEL', 'NACHOS', 'SANDWICH', 'TOAST', 'BAGEL', 'MUFFIN', 'CROISSANT',
  'DONUT', 'CUPCAKE', 'PIE', 'CAKE', 'BROWNIE', 'FUDGE', 'TOFFEE',

  // Animals
  'PUPPY', 'KITTEN', 'TURTLE', 'PANDA', 'KOALA', 'PENGUIN', 'DOLPHIN', 'OTTER',
  'BUNNY', 'HAMSTER', 'GUINEAPIG', 'CHINCHILLA', 'FERRET', 'RACCOON', 'FOX',
  'WOLF', 'BEAR', 'TIGER', 'LION', 'ELEPHANT', 'GIRAFFE', 'ZEBRA', 'RHINO',
  'HIPPO', 'GORILLA', 'MONKEY', 'CHIMPANZEE', 'ORANGUTAN', 'SLOTH', 'ANTEATER',
  'ARMADILLO', 'PLATYPUS', 'ECHIDNA', 'KANGAROO', 'WALLABY', 'EMU', 'OSTRICH',
  'PEACOCK', 'FLAMINGO', 'TOUCAN', 'PARROT', 'OWL', 'EAGLE', 'HAWK', 'FALCON',
  'PENGUIN', 'SEAGULL', 'DUCK', 'SWAN', 'GOOSE', 'CHICKEN', 'ROOSTER',
  'TURKEY', 'PIGEON', 'SPARROW', 'ROBIN', 'BLUEJAY', 'CARDINAL', 'HUMMINGBIRD',
  'BUTTERFLY', 'LADYBUG', 'BEE', 'ANT', 'SPIDER', 'CRICKET', 'GRASSHOPPER',
  'DRAGONFLY', 'FIREFLY', 'LIGHTNINGBUG', 'MOSQUITO', 'FLY', 'MOTH', 'CATERPILLAR',

  // Nature
  'SUNNY', 'RAINBOW', 'STAR', 'MOON', 'CLOUD', 'SUNSET', 'BEACH', 'MOUNTAIN',
  'FOREST', 'RIVER', 'LAKE', 'OCEAN', 'STREAM', 'WATERFALL', 'CAVE', 'VOLCANO',
  'DESERT', 'ISLAND', 'VALLEY', 'MEADOW', 'GARDEN', 'FLOWER', 'TREE', 'LEAF',
  'GRASS', 'MOSS', 'FERN', 'CACTUS', 'SUCCULENT', 'ROSE', 'TULIP', 'DAISY',
  'SUNFLOWER', 'LILY', 'ORCHID', 'DAFFODIL', 'PANSY', 'VIOLET', 'POPPY',
  'LAVENDER', 'LILAC', 'JASMINE', 'GARDENIA', 'MAGNOLIA', 'CHERRYBLOSSOM',
  'MAPLE', 'OAK', 'PINE', 'PALM', 'BAMBOO', 'WILLOW', 'BIRCH', 'CEDAR',
  'SEQUOIA', 'REDWOOD', 'ASPEN', 'ELM', 'CHESTNUT', 'WALNUT', 'ALMOND',
  'PECAN', 'HAZELNUT', 'PISTACHIO', 'CASHEW', 'MACADAMIA', 'BRAZILNUT',

  // Weather & Seasons
  'SUNSHINE', 'RAINDROP', 'SNOWFLAKE', 'THUNDER', 'LIGHTNING', 'BREEZE',
  'WINDY', 'FOGGY', 'MISTY', 'FROSTY', 'ICICLE', 'HAILSTONE', 'RAINBOW',
  'SUNSET', 'SUNRISE', 'DAWN', 'DUSK', 'TWILIGHT', 'NIGHT', 'DAY',
  'SPRING', 'SUMMER', 'AUTUMN', 'WINTER', 'SEASON', 'WEATHER', 'CLIMATE',
  'TEMPERATURE', 'HUMIDITY', 'PRESSURE', 'FORECAST', 'STORM', 'HURRICANE',
  'TORNADO', 'BLIZZARD', 'AVALANCHE', 'LANDSLIDE', 'EARTHQUAKE', 'TSUNAMI',
  'VOLCANO', 'ERUPTION', 'LAVA', 'MAGMA', 'ASH', 'SMOKE', 'FIRE',

  // Emotions & Feelings
  'HAPPY', 'SMILE', 'LAUGH', 'JOY', 'CHEER', 'DELIGHT', 'PLEASURE',
  'EXCITEMENT', 'THRILL', 'ADVENTURE', 'FUN', 'PLAY', 'GAME', 'SPORT',
  'DANCE', 'SING', 'MUSIC', 'SONG', 'MELODY', 'RHYTHM', 'BEAT',
  'HARMONY', 'CHORD', 'NOTE', 'TUNE', 'VOICE', 'CHOIR', 'BAND',
  'ORCHESTRA', 'PIANO', 'GUITAR', 'VIOLIN', 'DRUM', 'FLUTE', 'TRUMPET',
  'SAXOPHONE', 'CLARINET', 'HARP', 'CELLO', 'BASS', 'ACCORDION', 'HARMONICA',

  // Magic & Fantasy
  'MAGIC', 'SPELL', 'WIZARD', 'WITCH', 'WAND', 'POTION', 'CRYSTAL',
  'GEM', 'JEWEL', 'DIAMOND', 'RUBY', 'SAPPHIRE', 'EMERALD', 'PEARL',
  'OPAL', 'AMETHYST', 'TOPAZ', 'GARNET', 'AQUAMARINE', 'TURQUOISE', 'JADE',
  'ONYX', 'OBSIDIAN', 'QUARTZ', 'AGATE', 'JASPER', 'MALACHITE', 'LAPIS',
  'MOONSTONE', 'SUNSTONE', 'STARSTONE', 'RAINBOWSTONE', 'MAGICSTONE', 'DREAMSTONE',
  'WISHSTONE', 'HOPESTONE', 'LOVESTONE', 'FRIENDSTONE', 'PEACESTONE', 'JOYSTONE',

  // Space & Astronomy
  'STAR', 'MOON', 'SUN', 'PLANET', 'GALAXY', 'UNIVERSE', 'COSMOS',
  'NEBULA', 'COMET', 'METEOR', 'ASTEROID', 'ORBIT', 'GRAVITY', 'SPACE',
  'ROCKET', 'SPACESHIP', 'ASTRONAUT', 'ALIEN', 'UFO', 'MARS', 'VENUS',
  'JUPITER', 'SATURN', 'URANUS', 'NEPTUNE', 'PLUTO', 'MERCURY', 'EARTH',

  // Colors
  'RED', 'ORANGE', 'YELLOW', 'GREEN', 'BLUE', 'PURPLE', 'PINK',
  'BROWN', 'BLACK', 'WHITE', 'GRAY', 'SILVER', 'GOLD', 'BRONZE',
  'COPPER', 'BRASS', 'CHROME', 'PLATINUM', 'PEARL', 'IVORY', 'EBONY',
  'CRIMSON', 'SCARLET', 'RUBY', 'GARNET', 'BURGUNDY', 'MAROON', 'CHERRY',
  'ROSE', 'PINK', 'FUCHSIA', 'MAGENTA', 'PURPLE', 'VIOLET', 'LAVENDER',
  'LILAC', 'INDIGO', 'BLUE', 'NAVY', 'TEAL', 'TURQUOISE', 'AQUA',
  'CYAN', 'GREEN', 'EMERALD', 'JADE', 'OLIVE', 'LIME', 'YELLOW',
  'GOLD', 'AMBER', 'ORANGE', 'PEACH', 'CORAL', 'SALMON', 'BROWN',
  'TAN', 'BEIGE', 'CREAM', 'IVORY', 'WHITE', 'SILVER', 'GRAY',
  'BLACK', 'EBONY', 'CHARCOAL', 'SLATE', 'SMOKE', 'ASH', 'PEARL',

  // Time & Seasons
  'SPRING', 'SUMMER', 'AUTUMN', 'WINTER', 'SEASON', 'MONTH', 'WEEK',
  'DAY', 'NIGHT', 'DAWN', 'DUSK', 'SUNRISE', 'SUNSET', 'MORNING',
  'AFTERNOON', 'EVENING', 'MIDNIGHT', 'NOON', 'HOUR', 'MINUTE', 'SECOND',
  'TIME', 'CLOCK', 'WATCH', 'CALENDAR', 'DATE', 'YEAR', 'CENTURY',
  'DECADE', 'MILLENNIUM', 'ERA', 'AGE', 'PERIOD', 'MOMENT', 'INSTANT',

  // Weather & Nature
  'SUNSHINE', 'RAINDROP', 'SNOWFLAKE', 'THUNDER', 'LIGHTNING', 'BREEZE',
  'WIND', 'STORM', 'CLOUD', 'FOG', 'MIST', 'FROST', 'ICE', 'FIRE',
  'FLAME', 'SPARK', 'GLOW', 'SHINE', 'TWINKLE', 'SPARKLE', 'GLITTER',
  'RAINBOW', 'AURORA', 'NORTHERNLIGHTS', 'SOUTHERNLIGHTS', 'STARLIGHT', 'MOONLIGHT',
  'SUNLIGHT', 'DAYLIGHT', 'NIGHTLIGHT', 'FIRELIGHT', 'CANDLELIGHT', 'LAMPLIGHT',

  // Emotions & Feelings
  'HAPPY', 'SMILE', 'LAUGH', 'JOY', 'CHEER', 'DELIGHT', 'PLEASURE',
  'EXCITEMENT', 'THRILL', 'ADVENTURE', 'FUN', 'PLAY', 'GAME', 'SPORT',
  'DANCE', 'SING', 'MUSIC', 'SONG', 'MELODY', 'RHYTHM', 'BEAT',
  'HARMONY', 'CHORD', 'NOTE', 'TUNE', 'VOICE', 'CHOIR', 'BAND',
  'ORCHESTRA', 'PIANO', 'GUITAR', 'VIOLIN', 'DRUM', 'FLUTE', 'TRUMPET',
  'SAXOPHONE', 'CLARINET', 'HARP', 'CELLO', 'BASS', 'ACCORDION', 'HARMONICA',

  // Magic & Fantasy
  'MAGIC', 'SPELL', 'WIZARD', 'WITCH', 'WAND', 'POTION', 'CRYSTAL',
  'GEM', 'JEWEL', 'DIAMOND', 'RUBY', 'SAPPHIRE', 'EMERALD', 'PEARL',
  'OPAL', 'AMETHYST', 'TOPAZ', 'GARNET', 'AQUAMARINE', 'TURQUOISE', 'JADE',
  'ONYX', 'OBSIDIAN', 'QUARTZ', 'AGATE', 'JASPER', 'MALACHITE', 'LAPIS',
  'MOONSTONE', 'SUNSTONE', 'STARSTONE', 'RAINBOWSTONE', 'MAGICSTONE', 'DREAMSTONE',
  'WISHSTONE', 'HOPESTONE', 'LOVESTONE', 'FRIENDSTONE', 'PEACESTONE', 'JOYSTONE'
]; 